import { Header } from "./header";
import { SelectedTable } from "./components/table/selected-table";

export const SelectedSearchTermsPage = () => {
  return (
    <div className="space-y-6">
      <Header />
      <SelectedTable />
    </div>
  );
};
